import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";

function cleanValue(value) {
    if (value === null || value === undefined) return "";
    if (Array.isArray(value)) return value.join(", ");
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}

function safeBaseName(filename) {
    return String(filename || "musook-export")
        .replace(/\.[^/.]+$/, "")
        .replace(/[^a-z0-9-_]+/gi, "-")
        .replace(/^-+|-+$/g, "")
        .toLowerCase() || "musook-export";
}

function rowsAsMatrix(columns, rows) {
    return rows.map((row) => columns.map((column) => cleanValue(
        typeof column.value === "function" ? column.value(row) : row[column.key],
    )));
}

function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function exportTableCsv({ filename, columns, rows }) {
    const matrix = [columns.map((column) => column.header), ...rowsAsMatrix(columns, rows)];
    const csv = matrix
        .map((line) => line.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","))
        .join("\r\n");
    downloadBlob(new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8" }), `${safeBaseName(filename)}.csv`);
}

export function exportTableXlsx({ filename, columns, rows, sheetName = "Export" }) {
    const matrix = [columns.map((column) => column.header), ...rowsAsMatrix(columns, rows)];
    const worksheet = XLSX.utils.aoa_to_sheet(matrix);
    worksheet["!cols"] = columns.map((column) => ({ wch: Math.min(Math.max(String(column.header).length + 4, 12), 32) }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31) || "Export");
    XLSX.writeFile(workbook, `${safeBaseName(filename)}.xlsx`);
}

export function exportTablePdf({ filename, title, columns, rows }) {
    const matrix = rowsAsMatrix(columns, rows);
    const doc = new jsPDF({
        orientation: columns.length > 6 ? "landscape" : "portrait",
        unit: "pt",
        format: "a4",
    });
    doc.setFontSize(16);
    doc.setTextColor(20, 30, 45);
    doc.text(title || "Musook export", 40, 42);
    doc.setFontSize(9);
    doc.setTextColor(100, 110, 125);
    doc.text(`${rows.length} record${rows.length === 1 ? "" : "s"}`, 40, 58);
    autoTable(doc, {
        startY: 76,
        head: [columns.map((column) => column.header)],
        body: matrix,
        margin: { left: 40, right: 40 },
        styles: { fontSize: 8, cellPadding: 5, overflow: "linebreak" },
        headStyles: { fillColor: [18, 65, 76], textColor: 255, fontStyle: "bold" },
        alternateRowStyles: { fillColor: [244, 247, 248] },
        didDrawPage: (data) => {
            doc.setFontSize(8);
            doc.setTextColor(130, 140, 150);
            doc.text("Musook · Studio workspace", data.settings.margin.left, doc.internal.pageSize.height - 20);
        },
    });
    doc.save(`${safeBaseName(filename)}.pdf`);
}
